<div class="modal-content">
  <div class="modal-header">
    <h4>Vizsga részletes nézet</h4>
  </div>
  <div *ngIf="isLoading" class="modal-body">
    <div id="app-loader-container">
      <app-loader></app-loader>
    </div>
    <div id="loading-text">Adatok betöltése folyamatban</div>
  </div>
  <div *ngIf="!isLoading && model != null" class="modal-body">
    <div class="row mt-2">
      <div class="col-6 text-light">Vizsgatárgy</div>
      <div class="col-3 text-light">Pontszám</div>
      <div class="col-3 text-light">Százalék</div>
    </div>
    <div class="row mb-4">
      <div class="col-6 text-black">
        {{ courseTitle }}
      </div>
      <div class="col-3 text-black">{{ formatResult(model.totalReceivedScore ?? 0) }}/{{ model.totalScore ?? 1 }}</div>
      <div class="col-3 text-black">
        {{ formatResult((model.percentage ?? 0) * 100) }}
      </div>
    </div>
    <div class="row">
      <div *ngFor="let exercise of model.exercises; let sor = index">
        <div *ngIf="exercise.type == 'FillIn' || exercise.type == 'FillInNumber'" class="accordion-item">
          <h2 class="accordion-header">
            <button class="btn btn-lg btn-dark w-100" style="text-align: left" disabled type="button">
              {{ sor + 1 }}. kérdés: <span [innerHTML]="[exercise.description]"></span>
            </button>
          </h2>
          <div class="accordion-collapse collapse show">
            <div class="accordion-body">
              <div class="col-12 text-black">Válaszlehetőségek</div>
              <div style="border: dotted; padding: 10px">
                <div *ngFor="let answerOption of exercise.answerOptions; let i = index">
                  <div class="col-12 text-light">{{ i + 1 }}. mező: {{ answerOption.description }}</div>
                </div>
              </div>
            </div>
            <div class="accordion-body">
              <div class="col-12 text-black">Vizsgázó válaszai</div>
              <div *ngFor="let question of exercise.questions; let i = index">
                <div *ngFor="let userAnswer of question.userAnswers">
                  <div class="col-12 text-light">
                    <div [ngStyle]="{ color: userAnswer.isCorrect === true ? 'green' : 'red' }" #t>
                      <span *ngIf="t.style.color === 'green'" class="material-icons-outlined align-bottom">done</span>
                      <span *ngIf="t.style.color === 'red'" class="material-icons-outlined align-bottom">close</span>
                      {{ i + 1 }}. mező: {{ userAnswer.value }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="exercise.type == 'MultiChoice' || exercise.type == 'SingleChoice'" class="accordion-item">
          <h2 class="accordion-header">
            <button class="btn btn-lg btn-dark w-100" style="text-align: left" disabled type="button">
              {{ sor + 1 }}. kérdés: <span [innerHTML]="[exercise.description]"></span>
            </button>
          </h2>
          <div class="accordion-collapse collapse show">
            <div
              class="accordion-body img-container"
              *ngIf="exercise.asset != null && exercise.asset.assetType == AssetType.Image"
            >
              <img
                src="{{ exercise.asset.uri }}"
                alt="{{ exercise.asset.name }}"
                class="img-fluid"
                style="max-width: 100%; max-height: 300px; margin-bottom: 10px"
              />
            </div>
          </div>
          <div class="accordion-collapse collapse show">
            <div class="accordion-body">
              <div class="col-12 text-black">Válaszlehetőségek</div>
              <div style="border: dotted; padding: 10px">
                <div *ngFor="let answerOption of exercise.answerOptions">
                  <div class="col-12 text-light">
                    <div
                      class="accordion-body img-container"
                      *ngIf="answerOption.asset != null && answerOption.asset.assetType == AssetType.Image"
                    >
                      <img
                        src="{{ answerOption.asset.uri }}"
                        alt="{{ answerOption.asset.name }}"
                        class="img-fluid"
                        style="max-width: 100%; max-height: 300px; margin-bottom: 10px"
                      />
                    </div>
                    <div [ngStyle]="{ color: getMultiChoiceAnswerOptionColor(exercise?.questions, answerOption.id) }">
                      {{ answerOption.description }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="accordion-body">
              <div class="col-12 text-black">Vizsgázó válaszai</div>
              <div *ngFor="let question of exercise.questions">
                <div *ngFor="let userAnswer of question.userAnswers">
                  <div class="col-12 text-light">
                    <div [ngStyle]="{ color: userAnswer.isCorrect === true ? 'green' : 'red' }" #t>
                      <span *ngIf="t.style.color === 'green'" class="material-icons-outlined align-bottom">done</span>
                      <span *ngIf="t.style.color === 'red'" class="material-icons-outlined align-bottom">close</span>
                      {{ getQuestionText(exercise.answerOptions, userAnswer.answerOptionId) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="exercise.type == 'Sequencing'" class="accordion-item">
          <h2 class="accordion-header">
            <button class="btn btn-lg btn-dark w-100" style="text-align: left" disabled type="button">
              {{ sor + 1 }}. kérdés: <span [innerHTML]="[exercise.description]"></span>
            </button>
          </h2>
          <div class="accordion-collapse collapse show">
            <div class="accordion-body">
              <div>Helyes sorrend</div>
              <div style="border: dotted; padding: 10px">
                <div *ngFor="let correctAnswerId of exercise.questions![0].correctAnswers; let i = index">
                  <div class="col-12 text-light">
                    <div style="color: green">
                      {{ i + 1 }}. {{ getQuestionText(exercise.answerOptions, correctAnswerId) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="accordion-body">
              <div class="col-12 text-black">Vizsgázó által megadott sorrend</div>
              <div *ngFor="let question of exercise.questions">
                <div *ngFor="let userAnswer of question.userAnswers; let i = index">
                  <div class="col-12 text-light">
                    <div [ngStyle]="{ color: userAnswer.isCorrect === true ? 'green' : 'red' }" #t>
                      <span *ngIf="t.style.color === 'green'" class="material-icons-outlined align-bottom">done</span>
                      <span *ngIf="t.style.color === 'red'" class="material-icons-outlined align-bottom">close</span>
                      {{ i + 1 }}. {{ getQuestionText(exercise.answerOptions, userAnswer.answerOptionId) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="exercise.type == 'FillInSelect'" class="accordion-item">
          <h2>
            <button class="btn btn-lg btn-dark w-100" style="text-align: left" disabled type="button">
              {{ sor + 1 }}. kérdés: <span [innerHTML]="[exercise.description]"></span>
            </button>
          </h2>
          <div class="accordion-collapse collapse show">
            <div class="accordion-body">
              <div style="border: dotted; padding: 10px">
                <div *ngFor="let question of exercise.questions; let i = index">
                  <div>{{ i + 1 }}. Legördülőből kiválasztható lehetőségek</div>
                  <div *ngFor="let availableAnswer of question.availableAnswers" class="col-12 text-light">
                    <div
                      [ngStyle]="{
                        color:
                          question.correctAnswers != null && availableAnswer == question.correctAnswers[0]
                            ? 'green'
                            : 'red'
                      }"
                    >
                      - {{ getQuestionText(exercise.answerOptions, availableAnswer) }}
                    </div>
                  </div>
                  <br />
                </div>
              </div>
              <br />
              <div *ngFor="let question of exercise.questions; let i = index">
                <div *ngFor="let userAnswer of question.userAnswers">
                  <div class="col-12 text-light">
                    {{ i + 1 }}. Legördülő válasz:
                    <div [ngStyle]="{ color: userAnswer.isCorrect === true ? 'green' : 'red' }" #t>
                      <span *ngIf="t.style.color === 'green'" class="material-icons-outlined align-bottom">done</span>
                      <span *ngIf="t.style.color === 'red'" class="material-icons-outlined align-bottom">close</span>
                      {{ userAnswer.value }}
                    </div>
                  </div>
                </div>
                <br />
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="exercise.type == 'Pair'" class="accordion-item">
          <h2 class="accordion-header">
            <button class="btn btn-lg btn-dark w-100" style="text-align: left" disabled type="button">
              {{ sor + 1 }}. kérdés: <span [innerHTML]="[exercise.description]"></span>
            </button>
          </h2>
          <div class="accordion-collapse collapse show">
            <div
              class="accordion-body img-container"
              *ngIf="exercise.asset != null && exercise.asset.assetType == AssetType.Image"
            >
              <img
                src="{{ exercise.asset.uri }}"
                alt="{{ exercise.asset.name }}"
                class="img-fluid result-asset"
              />
            </div>
            <div class="accordion-body">
              <div class="col-12 text-black">Helyes párok</div>
              <div class="result-answer-box">
                <div *ngFor="let question of exercise.questions; let i = index" class="result-question">
                  <div class="result-question-title">{{ i + 1 }}. {{ question.description || question.title || 'Pár' }}</div>
                  <div *ngFor="let correctAnswerId of question.correctAnswers" class="result-answer result-answer-correct">
                    <span class="material-icons-outlined align-bottom">done</span>
                    <span [innerHTML]="getQuestionText(exercise.answerOptions, correctAnswerId)"></span>
                    <ng-container *ngIf="getAnswerOption(exercise.answerOptions, correctAnswerId) as answerOption">
                      <img
                        *ngIf="answerOption.asset != null && answerOption.asset.assetType == AssetType.Image"
                        src="{{ answerOption.asset.uri }}"
                        alt="{{ answerOption.asset.name }}"
                        class="img-fluid result-asset"
                      />
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
            <div class="accordion-body">
              <div class="col-12 text-black">Vizsgázó párosításai</div>
              <div class="result-answer-box">
                <div *ngFor="let question of exercise.questions; let i = index" class="result-question">
                  <div class="result-question-title">{{ i + 1 }}. {{ question.description || question.title || 'Pár' }}</div>
                  <div
                    *ngFor="let userAnswer of question.userAnswers"
                    class="result-answer"
                    [class.result-answer-correct]="userAnswer.isCorrect === true"
                    [class.result-answer-incorrect]="userAnswer.isCorrect !== true"
                  >
                    <span class="material-icons-outlined align-bottom">
                      {{ userAnswer.isCorrect === true ? 'done' : 'close' }}
                    </span>
                    <span [innerHTML]="getQuestionText(exercise.answerOptions, userAnswer.answerOptionId)"></span>
                    <ng-container *ngIf="getAnswerOption(exercise.answerOptions, userAnswer.answerOptionId) as answerOption">
                      <img
                        *ngIf="answerOption.asset != null && answerOption.asset.assetType == AssetType.Image"
                        src="{{ answerOption.asset.uri }}"
                        alt="{{ answerOption.asset.name }}"
                        class="img-fluid result-asset"
                      />
                    </ng-container>
                  </div>
                  <div *ngIf="!question.userAnswers?.length" class="result-answer text-muted">Nincs megadott válasz.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="exercise.type == 'Group'" class="accordion-item">
          <h2 class="accordion-header">
            <button class="btn btn-lg btn-dark w-100" style="text-align: left" disabled type="button">
              {{ sor + 1 }}. kérdés: <span [innerHTML]="[exercise.description]"></span>
            </button>
          </h2>
          <div class="accordion-collapse collapse show">
            <div
              class="accordion-body img-container"
              *ngIf="exercise.asset != null && exercise.asset.assetType == AssetType.Image"
            >
              <img
                src="{{ exercise.asset.uri }}"
                alt="{{ exercise.asset.name }}"
                class="img-fluid result-asset"
              />
            </div>
            <div class="accordion-body">
              <div *ngFor="let question of exercise.questions; let i = index" class="result-group">
                <div class="result-question-title">
                  {{ question.title ? question.title + '. ' : i + 1 + '. ' }}{{ question.description || 'Csoport' }}
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="text-black">Helyes csoportelemek</div>
                    <div class="result-answer-box">
                      <div
                        *ngFor="let correctAnswerId of question.correctAnswers"
                        class="result-answer result-answer-correct"
                      >
                        <span class="material-icons-outlined align-bottom">done</span>
                        <span [innerHTML]="getQuestionText(exercise.answerOptions, correctAnswerId)"></span>
                        <ng-container *ngIf="getAnswerOption(exercise.answerOptions, correctAnswerId) as answerOption">
                          <img
                            *ngIf="answerOption.asset != null && answerOption.asset.assetType == AssetType.Image"
                            src="{{ answerOption.asset.uri }}"
                            alt="{{ answerOption.asset.name }}"
                            class="img-fluid result-asset"
                          />
                        </ng-container>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="text-black">Vizsgázó csoportelemei</div>
                    <div class="result-answer-box">
                      <div
                        *ngFor="let userAnswer of question.userAnswers"
                        class="result-answer"
                        [class.result-answer-correct]="userAnswer.isCorrect === true"
                        [class.result-answer-incorrect]="userAnswer.isCorrect !== true"
                      >
                        <span class="material-icons-outlined align-bottom">
                          {{ userAnswer.isCorrect === true ? 'done' : 'close' }}
                        </span>
                        <span [innerHTML]="getQuestionText(exercise.answerOptions, userAnswer.answerOptionId)"></span>
                        <ng-container
                          *ngIf="getAnswerOption(exercise.answerOptions, userAnswer.answerOptionId) as answerOption"
                        >
                          <img
                            *ngIf="answerOption.asset != null && answerOption.asset.assetType == AssetType.Image"
                            src="{{ answerOption.asset.uri }}"
                            alt="{{ answerOption.asset.name }}"
                            class="img-fluid result-asset"
                          />
                        </ng-container>
                      </div>
                      <div *ngIf="!question.userAnswers?.length" class="result-answer text-muted">
                        Nincs megadott válasz.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-dark me-auto" (click)="close()">Vissza</button>
    <button
      type="button"
      class="btn btn-primary text-white"
      (click)="exportPdf()"
      [disabled]="isPdfLoading || isLoading"
    >
      <span *ngIf="isPdfLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      <span *ngIf="!isPdfLoading" class="material-icons me-1 align-bottom">picture_as_pdf</span>
      PDF export
    </button>
    <button type="button" class="btn btn-primary text-white" (click)="save()">
      <span class="material-icons me-1 align-bottom">save</span>
      Json letöltése
    </button>
  </div>
</div>
